export function Footer() {
  const year = new Date().getFullYear();

  return `
    <footer class="bg-primary text-white dark:bg-bg-dark">
      <div class="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-2 lg:grid-cols-[1.35fr_0.8fr_0.9fr_1.05fr] lg:px-8">
        <div>
          <img src="/brand/light_logo_tagline.png" alt="Pinaroyalcargo" class="mb-5 h-14 w-auto max-w-[285px] object-contain" />
          <p class="max-w-md text-sm leading-6 text-white/75 dark:text-text-muted-dark">
            Reliable cargo movement with clear shipment visibility from pickup to delivery.
          </p>
          <div class="mt-5 space-y-2 text-sm text-white/75">
            <p class="font-semibold text-white">Al Quoz Warehouse</p>
            <p>Warehouse 6-8, Hadaeq Mohammed Bin Rashid</p>
            <p>12th St. Al Quoz Industrial Area 3</p>
            <p>P.O. Box 127118, Dubai, UAE</p>
          </div>
        </div>
        
        <div>
          <h2 class="text-sm font-semibold uppercase tracking-wide text-accent">Quick Links</h2>
          <nav class="mt-4 grid gap-3 text-sm text-white/75" aria-label="Footer navigation">
            <a href="/about" data-link class="transition hover:text-accent">About Us</a>
            <a href="/services" data-link class="transition hover:text-accent">Our Services</a>
            <a href="/track" data-link class="transition hover:text-accent">Track Shipment</a>
            <a href="/contact" data-link class="transition hover:text-accent">Contact Us</a>
          </nav>
        </div>

        <div>
          <h2 class="text-sm font-semibold uppercase tracking-wide text-accent">Support</h2>
          <nav class="mt-4 grid gap-3 text-sm text-white/75" aria-label="Support links">
            <a href="/contact" data-link class="transition hover:text-accent">Get a Quote</a>
            <a href="/contact#feedback" data-link class="transition hover:text-accent">Feedback &amp; Reviews</a>
            <a href="/track" data-link class="transition hover:text-accent">Tracking Help</a>
          </nav>
        </div>

        <div>
          <h2 class="text-sm font-semibold uppercase tracking-wide text-accent">Contact</h2>
          <div class="mt-4 space-y-3 text-sm text-white/75">
            <p><span class="font-semibold text-white">Email:</span> info@pinaroyalcargo.com</p>
            <p><span class="font-semibold text-white">Opening hours:</span> Always Open</p>
          </div>
          <a href="/contact" data-link class="mt-6 inline-flex rounded bg-accent px-4 py-2 text-sm font-semibold text-primary transition hover:bg-accent-hover hover:text-white">
            Contact
          </a>
        </div>
      </div>
      <div class="border-t border-white/10 px-4 py-5 text-center text-xs text-white/60">
        <p>Copyright ${year} Pinaroyalcargo. All rights reserved.</p>
        <p class="mt-2 flex flex-wrap items-center justify-center gap-4">
          <a href="/terms-conditions" data-link class="transition hover:text-white">Terms &amp; Conditions</a>
          <span aria-hidden="true">&middot;</span>
          <a href="/privacy-policy" data-link class="transition hover:text-white">Privacy Policy</a>
          <span aria-hidden="true">&middot;</span>
          <a href="/refund-policy" data-link class="transition hover:text-white">Refund Policy</a>
        </p>
      </div>
    </footer>
  `;
}
